import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Events from './pages/Events';
import Donate from './pages/Donate';
import Gallery from './pages/Gallery';
import Career from './pages/Career';
import Blog from './pages/Blog';
import Contact from './pages/Contact';
import BecomeVolunteer from './pages/BecomeVolunteer';
import EventsDetail from './pages/EventsDetail';
import BlogDetail from './pages/BlogDetail';
import AnnualDinner from './pages/AnnualDinner';
import AnnualDinnerRegistration from './pages/AnnualDinnerRegistration';

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen bg-gray-50">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/events" element={<Events />} />
            <Route path="/EventsDetail" element={<EventsDetail />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/career" element={<Career />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blogDetail" element={<BlogDetail />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/donate" element={<Donate />} />
            <Route path="/become-volunteer" element={<BecomeVolunteer />} />
            <Route path="/annual-dinner" element={<AnnualDinner />} />
            <Route path="/annual-dinner/register" element={<AnnualDinnerRegistration />} /> {/* New Registration Route */}
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;